import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { SelectField } from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useUpdatePackageStatus from '../../../hooks/home/useUpdatePackageStatus';
import {
  UpdatePackageStatusDataType,
  UpdatePackageStatusInitialValues,
  UpdatePackageStatusSchema,
} from '../../../models/home/updatPackageStatus.model';

interface ISetPackageStatusModal {
  tdata: any;
}

const SetPackageStatusModal: React.FC<ISetPackageStatusModal> = ({ tdata }) => {
  const { updatePackageStatus, loading } = useUpdatePackageStatus();

  const onSubmit = (values: UpdatePackageStatusDataType, actions: any) => {
    // const clearerId = getClearerId(clearersList, values.clearer.split(' ')[1]);
    updatePackageStatus({ status: values.status, cargoId: tdata.id });

    // if (resetInputFields) {
    actions.resetForm(UpdatePackageStatusInitialValues);
    // }
  };

  return (
    <ModalContentWrapper title={'Update Package Status'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={UpdatePackageStatusInitialValues}
          schema={UpdatePackageStatusSchema}
          onSubmit={onSubmit}
        >
          <SelectField label="status" name="clearer">
            <option>Cleared</option>
            <option>Missing</option>
            <option>Siezed</option>
          </SelectField>

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Update Status
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};

export default SetPackageStatusModal;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
